import { ScrollButtons } from 'thalia-elements/modules/lists/scroll-buttons/main.js';

class NavigationSchnelleinstiegTags extends HTMLElement {
    constructor() {
        super();
        this.scrollButtons = null;
    }
    connectedCallback() {
        const liste = this.querySelector('.linklist');
        if (!liste) {
            return;
        }
        this.scrollButtons = new ScrollButtons(liste);
        this.scrollButtons.init();
    }
    disconnectedCallback() {
        this.scrollButtons?.destroy();
    }
}

if (!customElements.get('navigation-schnelleinstieg-tags')) {
    customElements.define('navigation-schnelleinstieg-tags', NavigationSchnelleinstiegTags);
}
